export enum ModuleQuestionFieldType {
	QUESTIONS_SELECT = 'QUESTIONS_SELECT',
	CHECKBOXES = 'CHECKBOXES',
	LONGTEXT = 'LONGTEXT',
	CHECKBOX = 'CHECKBOX',
	LANGUAGE = 'LANGUAGE',
	RADIOS = 'RADIOS',
	SLIDER = 'SLIDER',
	NUMBER = 'NUMBER',
	SELECT = 'SELECT',
	MONTH = 'MONTH',
	EMAIL = 'EMAIL',
	DATE = 'DATE',
	FILE = 'FILE',
	NOTE = 'NOTE',
	TEXT = 'TEXT',
}
